import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedNumber } from "react-intl";
import CommissionReportVendorRow from "../CommissionReportVendorRow/CommissionReportVendorRow";
import * as _ from "lodash-es";
import ICommissionUserDetail from "../../../../../models/ICommissionUserDetail";

type Props = {
    userDetailRow: ICommissionUserDetail;
};

type State = {
    vendorViewVisible: boolean;
};

class CommissionReportRow extends Component<Props, State> {
    readonly state: State = {
        vendorViewVisible: false,
    };

    toggleVendorView = (allowToggle: boolean) => {
        if (!allowToggle) {
            return null;
        }

        this.setState({
            vendorViewVisible: !this.state.vendorViewVisible,
        });
    };

    render() {
        const vendorGuids = Object.keys(this.props.userDetailRow.vendors);

        return (
            <div className={"d-flex flex-column mb-3 border-secondary border-bottom mb-2"}>
                <div className={"d-flex"}>
                    <span
                        className={"me-auto " + (vendorGuids.length ? "pointer" : "")}
                        onClick={(e: any) => {
                            this.toggleVendorView(!!vendorGuids.length);
                        }}>
                        <span className={"me-2 " + (vendorGuids.length ? "" : "invisible")}>
                            <i className={"fas " + (this.state.vendorViewVisible ? "fa-chevron-down" : "fa-chevron-up")}></i>
                        </span>
                        {this.props.userDetailRow.name}
                    </span>
                    <span>
                        <FormattedNumber value={Number(this.props.userDetailRow.grandTotal)} minimumFractionDigits={2} />
                    </span>
                </div>
                {this.state.vendorViewVisible
                    ? _.map(vendorGuids, (vendorGuid: string) => {
                          const vendorDetail = this.props.userDetailRow.vendors[vendorGuid];

                          return <CommissionReportVendorRow key={vendorGuid} vendorDetail={vendorDetail} />;
                      })
                    : null}
            </div>
        );
    }
}

export default CommissionReportRow;
